import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = { class: "global-actions" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "workspace" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, "Deployment planning workspace"),
        _createElementVNode("h1", null, "Customer Manager")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "ghost",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.generate(5)))
        }, " Generate 5 "),
        _createElementVNode("button", {
          type: "button",
          class: "ghost",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generate(10)))
        }, " Generate 10 "),
        _createElementVNode("button", {
          type: "button",
          class: "danger",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeAll && _ctx.removeAll(...args)))
        }, " Delete All Data ")
      ])
    ]),
    (_ctx.state.ui.notice)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(['notice', `notice--${_ctx.state.ui.notice.kind}`])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.state.ui.notice.text), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearNotice && _ctx.clearNotice(...args)))
          }, "Dismiss")
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: tab.path,
          to: tab.path,
          class: "tab"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tab.label), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}